import {ref} from "vue";

export type NotificationType = 'success' | 'error' | 'info';

interface NotificationItem {
    message: string;
    type: NotificationType;
}

const visible = ref(false);
const current = ref<NotificationItem>({message: '', type: 'info'});
let timeout: ReturnType<typeof setTimeout> | null = null;

function show(message: string, type: NotificationType, duration = 4000) {
    if (timeout) clearTimeout(timeout);
    current.value = {message, type};
    visible.value = true;
    timeout = setTimeout(() => {
        visible.value = false;
    }, duration);
}

export function useNotification() {
    return {
        visible,
        current,
        success(message: string) {
            show(message, 'success');
        },
        error(message: string) {
            show(message, 'error', 5000);
        },
        info(message: string) {
            show(message, 'info');
        },
        close() {
            visible.value = false;
            if (timeout) clearTimeout(timeout);
        },
    };
}
